import { 
  UserCheck, 
  CreditCard, 
  GamepadIcon, 
  Bell, 
  BarChart, 
  RefreshCcw,
  Shield,
  Users,
  Lock,
  FileText,
  Eye,
  Zap
} from 'lucide-react';

export const mockData = {
  stats: {
    users: 25000,
    contests: 150,
    prizes: 50
  },
  
  howItWorks: [
    {
      icon: UserCheck,
      title: 'Register & Verify',
      description: 'Complete KYC with Aadhaar/PAN verification and mobile OTP for secure registration'
    },
    {
      icon: CreditCard,
      title: 'Buy a Ticket',
      description: 'Participate with instant digital invoice and secure payment'
    },
    {
      icon: GamepadIcon,
      title: 'Answer Questions',
      description: 'Answer questions on different topics to win exciting prizes!'
    }
  ],

  features: [
    {
      title: 'KYC Registration',
      description: 'Secure Aadhaar/PAN verification with OTP authentication',
      badge: 'Secure'
    },
    {
      title: 'Secure Payments',
      description: 'PCI-DSS compliant payment gateway with GST invoicing',
      badge: 'Trusted'
    },
    {
      title: 'Real Contest Participation',
      description: 'Timed GK & puzzle challenges with live leaderboards',
      badge: 'Live'
    },
    {
      title: 'Multi-channel Notifications',
      description: 'SMS, Email, and App push notifications for updates',
      badge: 'Instant'
    },
    {
      title: 'Public Leaderboard',
      description: 'Top 50 public rankings with transparent scoring system',
      badge: 'Transparent'
    },
    {
      title: 'Quick Refunds',
      description: 'Automated refund processing within 7 working days',
      badge: 'Fast'
    }
  ],

  prizes: [
    {
      rank: '1st',
      reward: 'Residential Plot',
      description: 'Prime location residential plot worth lakhs',
      value: '₹25,00,000+'
    },
    {
      rank: '2nd-10th',
      reward: 'Smartwatches',
      description: 'Premium branded smartwatches for top performers',
      value: '₹15,000 each'
    },
    {
      rank: '11th-50th',
      reward: 'Double Refund',
      description: 'Get back double your entry fee',
      value: 'Cash Prize'
    },
    {
      rank: '51st-200th',
      reward: 'Entry Fee Refund',
      description: 'Full entry fee refund',
      value: 'Refund'
    },
    {
      rank: 'All Participants',
      reward: 'Digital Certificate',
      description: 'Official participation certificate with score details and achievements',
      value: 'Complimentary'
    }
  ],

  trustFeatures: [
    {
      icon: Shield,
      title: 'Skill-Based Only',
      description: 'No luck involved - pure skill and knowledge testing platform'
    },
    {
      icon: Users,
      title: 'Fraud Prevention',
      description: 'Advanced duplicate detection and device tracking systems'
    },
    {
      icon: Lock,
      title: 'Secure Payments',
      description: 'PCI-DSS certified payment processing with encryption'
    },
    {
      icon: FileText,
      title: 'GST Compliant',
      description: 'Fully registered with GST and TDS compliance'
    },
    {
      icon: Eye,
      title: '2FA Security',
      description: 'Two-factor authentication for admin access and bot protection'
    },
    {
      icon: Zap,
      title: 'Real-time Monitoring',
      description: 'Live contest monitoring and automated fair participation detection'
    }
  ],

  adminFeatures: [
    {
      icon: BarChart,
      title: 'Analytics Dashboard',
      description: 'Real-time contest metrics and user engagement stats'
    },
    {
      icon: Users,
      title: 'User Management',
      description: 'Complete participant profiles and KYC verification system'
    },
    {
      icon: GamepadIcon,
      title: 'Contest Control',
      description: 'Create, schedule and manage contest parameters'
    },
    {
      icon: FileText,
      title: 'Question Bank',
      description: '1000+ curated GK and puzzle questions with difficulty levels'
    }
  ],

  testimonials: [
    {
      name: 'Rahul Sharma',
      location: 'Mumbai',
      text: 'Won my first smartwatch in just my third attempt! The questions are challenging but fair.',
      rating: 5,
      avatar: 'RS'
    },
    {
      name: 'Priya Patel',
      location: 'Delhi',
      text: 'Love the transparency! You can see exactly how scoring works. Very trustworthy platform.',
      rating: 5,
      avatar: 'PP'
    },
    {
      name: 'Amit Kumar',
      location: 'Bangalore',
      text: 'Fast payouts and great customer service. Already recommended to my friends!',
      rating: 5,
      avatar: 'AK'
    }
  ],

  faqs: [
    {
      question: 'How is WinQuizz different from gambling?',
      answer: 'WinQuizz is 100% skill-based. Winners are determined by knowledge and speed, not luck or chance.'
    },
    {
      question: 'When do I get my refund?',
      answer: 'Refunds are processed automatically within 7 working days to your original payment method.'
    },
    {
      question: 'What happens if there\'s a tie?',
      answer: 'In case of tied scores, the participant who submitted answers faster wins the higher prize.'
    },
    {
      question: 'Can I participate in multiple contests?',
      answer: 'Yes! You can participate in as many contests as you like, each requires a separate entry fee.'
    }
  ]
};